import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import { getResponses } from "redux/actions/responses";
import { changeURLWithoutReload } from "../../../utils/helpers";
import { ResponsesTable } from "../../../components/dashboard/responses";
import { SEARCH_NAME, SORT_NAME } from "../../../utils/constants";

function Root() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [params, setParams] = React.useState({});
  const [isParsing, setIsParsing] = React.useState(true);
  const storeResponses = useSelector((store) => store.responses.list);

  // only run for the first time visit page
  React.useEffect(() => {
    setParams(queryString.parse(location.search));
    setIsParsing(false);
  }, [location.search]);

  React.useEffect(() => {
    if (isParsing) return;
    dispatch(getResponses(params));
  }, [params, isParsing]);

  const handleChangeURL = (newParams) => {
    changeURLWithoutReload(
      location.pathname,
      `${location.pathname}?${queryString.stringify(newParams)}`
    );
  };

  const handlePageChange = (e) => {
    const newParams = { ...params, page: e.selected + 1 };
    setParams(newParams);
    handleChangeURL(newParams);
  };

  const handleSort = (column, direction) => {
    const newParams = {
      ...params,
      [SORT_NAME]: `${column} ${direction}`,
      page: 1,
    };
    setParams(newParams);
    handleChangeURL(newParams);
  };

  const handleSearch = (e) => {
    const newParams = {
      ...params,
      page: 1,
      [SEARCH_NAME]: e.target.value,
    };
    setParams(newParams);
    handleChangeURL(newParams);
  };

  return (
    <ResponsesTable
      store={storeResponses}
      onPageChange={handlePageChange}
      params={params}
      onSort={handleSort}
      onSearch={handleSearch}
    />
  );
}

export default Root;
